import { CompanyInfos } from "./CompanyInfos.js";
import { SalesZone } from "./SalesZone.js";
import { Settings } from "./Settings.js";
import { Product } from "./Product.js";
import { StripeAccount } from "./StripeAccount.js";
import { Discount } from "./Discount.js";
import { v4 as uuid } from 'uuid';
export class Company {
    id;
    owner = null;
    name = null;
    subscribedPlan = null;
    quotaExceeded = false;
    quotaSeverelyExceeded = false;
    hasAnActiveSubscription = false;
    hasAValidStripeConnection = false;
    settings = null;
    stripeAccount = null;
    infos = null;
    salesZones = null;
    discounts = [];
    products = [];
    taxInfos = null;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'settings') {
                            value = new Settings(id, value);
                        }
                        if (key == 'infos') {
                            value = new CompanyInfos(id, value);
                        }
                        if (key == 'stripeAccount') {
                            value = new StripeAccount(id, value);
                        }
                        if (key == 'products' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new Product(item.id, item));
                            }
                            value = items;
                        }
                        if (key == 'salesZones' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new SalesZone(item.id, item));
                            }
                            value = items;
                        }
                        if (key == 'discounts' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new Discount(item.id, item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    getProductById(id) {
        // console.log('getProductById', id, this.products)
        if (id == null) {
            return null;
        }
        if (this.products == null) {
            return null;
        }
        let product = this.products.filter((el) => el.id == id).shift();
        return product || null;
    }
    getSalesZoneById(id) {
        // console.log('getProductById', id, this.products)
        if (id == null) {
            return null;
        }
        if (this.salesZones == null) {
            return null;
        }
        let salesZone = this.salesZones.filter((el) => el.id == id).shift();
        return salesZone || null;
    }
    getDiscountById(id) {
        if (id == null) {
            return null;
        }
        if (this.discounts == null) {
            return null;
        }
        for (let discount of this.discounts) {
            if (discount.id == id) {
                return discount;
            }
        }
        return null;
    }
    getDefaultPointofSale() {
        let defaults = this.getDefaultPointofSaleAndZone();
        return defaults && defaults.pointOfSale ? defaults.pointOfSale : null;
    }
    getDefaultSalesZone() {
        let defaults = this.getDefaultPointofSaleAndZone();
        return defaults && defaults.salesZone ? defaults.salesZone : null;
    }
    getDefaultPointofSaleAndZone() {
        if (!this.settings) {
            console.error("@Company#getDefaultPointofSale: no settings");
            return null;
        }
        if (!this.settings.defaultPointofsaleId) {
            console.error("@Company#getDefaultPointofSale: no defaultPointofsaleId");
            return null;
        }
        if (!this.salesZones || this.salesZones.length == 0) {
            return null;
        }
        for (let zone of this.salesZones) {
            if (!zone.pointsOfSale) {
                return null;
            }
            for (let pos of zone.pointsOfSale) {
                if (pos.id == this.settings.defaultPointofsaleId) {
                    return {
                        salesZone: zone,
                        pointOfSale: pos
                    };
                }
            }
        }
        return null;
    }
}
